import Emitter from "./Emitter";
import EmitterUtils from "../EmitterUtils";
import {playMode} from "../../constants";

let BalanceChange_lastBalanceFromGame; // Module-level variable to persist across all instances. Static variable did not work out since minified JS is a mess and references to classes are reused.
let lastBalanceByWallet = {}; // Store wallets' last balances

export default class BalanceChange extends Emitter {

    constructor(gb) {
        super(gb);
    }

    SPINGAMES_handler(data) {
        if (data && typeof data !== "object") {
            this.emitTop({ event: "round_result", balance: data });
            this.emitParent({ event: "round_result", balance: data });
        }
    }

    EXCITE_handler(balance) {
        this.emitParent({ event: "setBalance", payload: { balance: balance }});
    }

    PLAYTECH_handler(balance) {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('balanceupdate')) {
            let obj = {
                _type: "ucip.balanceupdate.g2wBalanceUpdateNotification",
                balance: {
                    value: typeof balance === "number" ? balance/100 : balance,
                    winAmount: 0,
                }
            }

            if (this.gb.settings.nativeMobileApp) {
                obj.handled = true;
                window.parent.postMessage(JSON.stringify(obj));

            } else {
                this.emitParent(JSON.stringify(obj));
            }
        }
    }

    /**
     * FOL (4 Leaf) game provider is sending balance change event right bet is placed. For some wallets like LNW there is handling of bonus balance which is retrieved from
     * backend using websocket message and that is executed with a slight delay. Delay to allow bonus balance to be updated before sending the event to the wallet.
     * If other wallets complain due to delay then this event can be made FOL-LNW specific.
     */
    FOL_LNWOGS_handler(balance) {
        let currentDate = new Date().getTime();

        if (this.gb.settings.playMode && this.gb.settings.playMode === playMode.FUN) {
            // Fun play, always update the balance as there is no communication with backend and there is no bonus balance
            this.LNWOGS_handler(balance);
        } else if (BalanceChange_lastBalanceFromGame !== undefined && BalanceChange_lastBalanceFromGame < balance) {
            // win amount > 0, send the request
            this.LNWOGS_handler(balance);
        } else if (this.gb.wallet?.tmpBalance?.lastUpdated && currentDate < EmitterUtils.addToDate(this.gb.wallet.tmpBalance.lastUpdated, EmitterUtils.TimeUnits.MILLISECONDS, 350).getTime()) {
            // On bet or if an additional balanceChange event is sent, only send the event if the balance was updated from the backend.
            // FOL sends balanceUpdate before the actual balance is returned from the backend and this causes issues with bonus amount calculation on a bet.
            this.LNWOGS_handler(balance);
        }

        BalanceChange_lastBalanceFromGame = balance;
    }

    LNWOGS_handler(balance) {
        if (balance < 0) return;

        let preSpinBalanceDeduction = false,
            b = JSON.parse(this.gb.settings.walletExtraInfoOnAuthenticate);

        if (this.gb.balanceVersion && this.gb.balanceVersion % 1 !== 0) {
            preSpinBalanceDeduction = true; // this is only for Bragg games, that send balance version xxx.5 on preSpin (to set UI correctly
        }

        let realBalance = Math.round((balance / 100) * 100) / 100,
            bonusBalance = b.bonusBalance ?? 0;

        if (this.gb.wallet?.tmpBalance) {
            bonusBalance = this.gb.wallet.tmpBalance.bonusBalance ?? 0;
        }

        if (preSpinBalanceDeduction && bonusBalance > 0) {
            bonusBalance = Math.round((bonusBalance - (this.gb.betAmount / 100)) * 100) / 100;
        }

        if (bonusBalance < 0) {
            // the spin where he ran out of bonus money, so some goes from bonus and some from realBalance

            // TODO: not totally sure if ok to add betAmount back to realBalance ... if not ok, revisit this logic ... LOOKS LIKE THIS IS NOT NEEDED ... REMOVE AFTER CONFIRMATION BY OPERATOR
            // realBalance = (balance + this.gb.betAmount) / 100;

            this.gb.wallet.balanceChange(realBalance + bonusBalance, 0);
        } else {
            let rb = Math.round((realBalance - bonusBalance) * 100) / 100;
            this.gb.wallet.balanceChange(rb, bonusBalance);
        }
    }

    SOFTSWISS_handler(balance) {
        let balanceInMajorUnit = balance / 100;
        let currency = this.gb.settings.currencyCode;
        this.emitParent({type: "a8r:v1:gtp:balance_update", payload: { balance: balanceInMajorUnit, currency: currency}});
    }

    VEGASSOFTWARE_handler(balance) {
        const walletKey = this.gb.walletProtocol;
        let actionType = "credit";
        
        if (lastBalanceByWallet[walletKey] !== undefined && balance < lastBalanceByWallet[walletKey]) {
            actionType = "debit";
        }
        
        lastBalanceByWallet[walletKey] = balance;

        this.emitTop({
            type: "UPDATE_BALANCE",
            balance: Math.round(balance * 100) / 100,
            action_type: actionType
        });
    }

    _default(balance) {
        if(balance && balance.payload) {
            this.gb.balance = balance.payload.balance;
        } else {
            this.gb.balance = balance;
        }

        this.emitTop({ wpgaction: "balance", param: { balance: balance } });
        this.emitParent({ wpgaction: "balance.parent", param: { balance: balance } });
        this.emitiOS({ wpgaction: "balance", param: { balance: balance } });

        this.emitTop({ eventName: "balanceUpdated", param: { balance: balance } });
        this.emitParent({ eventName: "balanceUpdated.parent", param: { balance: balance } });
        this.emitiOS({ eventName: "balanceUpdated", param: { balance: balance } });
    }
}
